    <template>
      <div>
        <section class="section is-title-bar">
          <div class="level">
            <div class="level-left">
              <div class="level-item">
                <h1 class="title is-5">Edit Student Details</h1>
              </div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <v-btn top left color="info" dark small v-on:click="editAppication(admissionID)">
                  Admission Form Fill - Offline
                </v-btn>
              </div>
              <div class="level-item">
                <a @click="$router.back()" class="button is-small is-link">Back to list</a>
              </div>
            </div>
          </div>
        </section>

        <section class="container section page-header section is-main-section">
          <form class="container" name="editStudent" @submit.prevent="saveStudent(studentData.studentEnrollment.id)">
            <div class="container">
              <StudentElement isWritable="true" v-model="studentData.studentEnrollment" formType="studEdit" />
            </div>

            <div class="container">
              <v-card-component title="Section" icon="mdi-human-child">
                <v-row>
                  <v-col cols="12" md="6">
                    <span class="body-2 font-weight-medium">Student Class</span>
                    <v-text-field type="text" placeholder="Class" v-model="studentData.class" disabled :readonly="true" class="my-0 py-1" single-line> </v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-autocomplete label="Section *" required placeholder="--Select--" v-model="studentData.sectionID" :items="classWiseSections" key="id" item-value="id" item-text="name">
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-component>
            </div>

            <div class="container">
              <ParentElement isWritable="true" parentType="father" v-model="studentData.studentEnrollment" formType="studEdit" />
            </div>
            <div class="container">
              <ParentElement isWritable="true" parentType="mother" v-model="studentData.studentEnrollment" formType="studEdit" />
            </div>
            <div class="container">
              <AddressElement isWritable="true" v-model="studentData.studentEnrollment" formType="studEdit" />
            </div>
            <footer class="column has-text-right">
              <button class="button is-success" type="submit" :disabled="hasClicked">
                Save
              </button>
            </footer>
          </form>
        </section>
      </div>
    </template>
<script>
import constants from '@/utils/constants'
import VCardComponent from '@/components/template/VCardComponent'
import StudentElement from '@/components/Forms/Elements/StudentElement'
import ParentElement from '@/components/Forms/Elements/ParentElement'
import AddressElement from '@/components/Forms/Elements/AddressElement'
import _ from 'lodash'
import moment from 'moment'
import Utils from '@/utils'

export default {
  name: 'studentEdit',
  props: ['studentId'],
  components: {
    StudentElement,
    ParentElement,
    AddressElement,
    VCardComponent
  },
  data () {
    return {
      studentData: {
        studentEnrollment: {}
      },
      enquiryCode: '',
      admissionID: '',
      newData: {},
      hasClicked: false,
      classList: [],
      classWiseSections: [],
      page: 1
    }
  },
  async created () {
    if (this.studentId) {
      this.getStudentData(this.studentId)
    }
    await this.getAcademicYears()
  },
  methods: {
    getSections: async function (classId) {
      try {
        let data = await http.get(`${constants.API_URL}/api/students/section/${classId}`)
        this.classWiseSections = data.data.studentSections
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    getAcademicYears: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYear = academicYear ? academicYear.id : ''
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },    
    getStudentData: async function (sId) {
      this.loadingComponent = this.$buefy.loading.open()
      let data = await http.get(`${constants.API_URL}/api/student/${sId}`)
      this.studentData = data.data
      if (this.studentData.classID) {
        this.getSections(this.studentData.classID)
      }

      this.enquiryCode = this.studentData.studentEnrollment.enquiry.enquiryCode
      this.admissionID = this.studentData.id
      this.studentData.studentEnrollment.studentID = this.studentData.id
      this.studentData.studentEnrollment.dateOfBirth =
            !this.studentData.studentEnrollment.dateOfBirth || this.studentData.studentEnrollment.dateOfBirth === 'Invalid date'
              ? ''
              : moment(this.studentData.studentEnrollment.dateOfBirth, 'YYYY-MM-DD').format('YYYY-MM-DD')
      this.studentData.studentEnrollment.gender =
            this.studentData.studentEnrollment.gender === 'MALE' ? 'Male' : this.studentData.studentEnrollment.gender === 'FEMALE' ? 'Female' : this.studentData.studentEnrollment.gender
      if (this.studentData.transportManagedByCenter) {
        this.studentData.studentEnrollment.transportMode = 'center'
      } else if (this.studentData.transportManagedByVendor) {
        this.studentData.studentEnrollment.transportMode = 'vendor'
      } else {
        this.studentData.studentEnrollment.transportMode = 'self'
      }
      this.loadingComponent.close()
    },
    childData: function (value) {
      _.assign(this.newData, value)
    },
    saveStudent: async function (sId) {
      if (this.studentData.isTransportBypass && this.studentData.studentEnrollment.transportMode === 'center') {
        this.$buefy.toast.open({
          message: 'This transport option requires completing the Centre’s transport fee payment before switching. Please complete the payment to proceed.',
          type: 'is-danger',
          duration: 8000
        })
        return
      }
      this.hasClicked = true
      this.loadingComponent = this.$buefy.loading.open()
      this.studentData.studentEnrollment.sectionID = this.studentData.sectionID
      let formData = this.studentData.studentEnrollment
      if (formData.transportMode === 'vendor') {
        formData.transportManagedByVendor = true
        formData.transportManagedByCenter = false
      } else if (formData.transportMode === 'center') {
        formData.transportManagedByCenter = true
        formData.transportManagedByVendor = false
      } else {
        formData.transportManagedByVendor = false
        formData.transportManagedByCenter = false
      }

      this.studentData.studentEnrollment.academicYearID = this.academicYear
      if (!this.studentData.studentEnrollment.gender) {
        this.errMsg('Gender value cannot be empty!')
        return false
      }
      try {
        if (formData.gender === 'Male' || formData.gender === 'Female') {
          await http.put(`${constants.API_URL}/api/student/${sId}`, formData)
          this.$router.push({ name: 'studentDetails', params: { current: this.page } })

          this.okMsg('Student Details Saved successfully!')
        } else {
          this.errMsg(`Error While Saving Student Details: Please select proper gender type`)
        }
        this.loadingComponent.close()
      } catch (e) {
        this.hasClicked = false
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While Saving Student Details: ${errorMessage}`)
      }
    },
    sendApplicationLink: async function (_enquiryCode, isOffline = false, isPayment = false) {
      try {
        this.isLoading = true
        const formData = {
          enquiryCode: this.enquiryCode,
          mode: isOffline ? 'OFFLINE' : 'ONLINE',
          type: isPayment ? constants.UserReferenceType.applicationForm : constants.UserReferenceType.applicationFormFill
        }
        if (isOffline) {
          formData.type = constants.UserReferenceType.applicationFormOffline
        }
        if (isOffline && !isPayment) {
          formData.type = constants.UserReferenceType.applicationFormFillOffline
        }
        /** * generate Application link */
        const response = await http.post(`${constants.API_URL}/api/generateApplicationFormLink`, formData)
        this.isLoading = false
        if (isOffline) {
          let route = this.$router.resolve({ name: 'applicationFormOffline', params: { refID: response.data } })
          if (isPayment) {
            route = this.$router.resolve({ name: 'OfflinePayments', params: { referenceID: response.data } })
          }
          window.open(route.href, '_blank')
        } else {
          return this.$dialog.info({
            text: 'Email is sent to parent for further process !',
            title: 'Info'
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    editAppication: async function (admissionID) {
      try {
        console.log('amID', admissionID)
        this.isLoading = true
        let route = this.$router.resolve({ name: 'ApplicationFormOfflineStudent', params: { admissionID: admissionID } })
        console.log('route', route)
        window.open(route.href, '_blank')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
